import { APIAccount, ApiAccountKey, ApiAccountKeyCreateRequest, ApiAccountKeyKeys } from "@sso/types";

export enum APIAccountKeys {
  ID = "apiAccountId",
  NAME = "name",
  DESCRIPTION = "description",
  ORGANISATION_ID = "organisationId",
  SOFTWARES_NAME = "softwares.Name",
  LAST_USED = "lastUsed",
  SOFTWARES = "softwares",
}
export const apiAccountInitialValues: APIAccount = {
  [APIAccountKeys.ID]: "",
  [APIAccountKeys.NAME]: "",
  [APIAccountKeys.DESCRIPTION]: "",
  [APIAccountKeys.SOFTWARES_NAME]: "",
  [APIAccountKeys.LAST_USED]: "",
  [APIAccountKeys.ORGANISATION_ID]: -1
};

export const apiAccountKeyInitialValues: ApiAccountKeyCreateRequest = {
  apiAccountId: "",
  descriptor: "",
  expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
};
